// patientsApi.js
import httpClient from '../../../shared/services/httpClient';

const patientsApi = {
  // Get all patients with optional filters
  getPatients: async (params = { paginate: true, per_page: 10 }) => {
    const response = await httpClient.get('/patients', { params });
    return response.data;
  },

  // Get single patient by ID
  getPatient: async (id) => {
    const response = await httpClient.get(`/patients/${id}`);
    return response.data;
  },

  // Create new patient
  createPatient: async (patientData) => {
    const response = await httpClient.post('/patients', patientData);
    return response.data;
  },

  // Update existing patient
  updatePatient: async (id, patientData) => {
    const response = await httpClient.put(`/patients/${id}`, patientData);
    return response.data;
  },

  // Delete patient
  deletePatient: async (id) => {
    const response = await httpClient.delete(`/patients/${id}`);
    return response.data;
  },

  // Get patient departments (for dropdown)
  getDepartments: async () => {
    const response = await httpClient.get('/organizations/departments/list');
    return response.data;
  },

  // Get patient positions (for dropdown)
  getDesignations: async () => {
    const response = await httpClient.get(`/organizations/designations/list`);
    return response.data;
  },
};

export default patientsApi;
